import { Client } from "../client"
import { batchActions } from 'redux-batched-actions'


export function selectSizeProfile(data) {
  return {
    type: 'SIZES_PROFILES_SELECTED',
    data
  }
}

export function cleanSelectedProfile(data) {
  return {
    type: 'SIZES_PROFILES_CLEANED',
    data
  }
}

export function cleanSelectedSizeValues() {
  return {
    type: 'CLEAN_SIZES_FORM',
  }
}

export function selectStandartSizes(data) {
  return {
    type: 'STANDART_SIZES_SELECTED',
    data
  }
}


export function changeSizeScenario(data) {
  return {
    type: 'SIZE_SCENARIO_CHANGED',
    data
  }
}

export function changeSizeActiveTab(data) {
  return {
    type: 'SIZE_TAB_CHANGED',
    data
  }
}

export function saveTemporarySmartSizes(data) {
  return {
    type: 'TEMPORARY_USER_MALE_SIZES_SAVED',
    data,
  }
}

function getNewProfile(profiles, newProfileId) {
  const filtered = profiles.shirtProfile.filter(p => p.objectId === newProfileId);
  const data = filtered.length > 0 ? filtered[0] : {};
  return {
    type: "DEFAULT_SIZE_PROFILES_RECEIVED",
    data,
  }
}

function receiveProfile(data) {
  return {
    type: 'SIZE_PROFILES_RECEIVED',
    data,
  };
}

function updateError(error) {
  return {
    type: 'SIZE_PROFILES_RECEIVED',
    error,
  };
}

export function setNewSizesProfileAsDefault(newProfileId) {
  return async (dispatch, getState) => {

    let data;
    try {
      data = await Client.getSizesProfilesList();
      if (data.error_id) {
        throw new Error(data.error_id);
      }
    } catch (error) {
      dispatch(updateError(error));
      return {
        error
      };
    }

    dispatch(
      batchActions(
        [
          receiveProfile(data),
          getNewProfile(data, newProfileId),
        ]
      ));
    return { data };
  };
}

export function getSizesProfileList(params) {
  return async (dispatch, getState) => {

    dispatch({
      type: 'SIZE_PROFILES_REQUEST'
    }, getState);

    let data;
    try {
      data = await Client.getSizesProfilesList(params);
      if (data.error_id) {
        throw new Error(data.error_id);
      }
    } catch (error) {
      dispatch(batchActions([{
        type: 'SIZE_PROFILES_REQUEST',
        error,
      },
      ]), getState);

      return {
        error
      };
    }

    dispatch(batchActions([{
      type: 'SIZE_PROFILES_RECEIVED',
      data
    }
    ]));

    return { data };
  };
}

export function createShirtProfileMaleBase(params) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'SIZE_PROFILE_CREATE_REQUEST'
    }, getState);
    let data;
    try {
      data = await Client.createShirtProfileMaleBase(params);
    } catch (error) {
      dispatch(batchActions([{
        type: 'SIZE_PROFILE_CREATE_FAIL',
        error,
      },
      ]), getState);
      return {
        error
      };
    }

    dispatch(batchActions([{
      type: 'SIZE_PROFILE_CREATE_REQUEST_SUCCESS',
      data
    }
    ]));

    return { data };
  };
}

export function getSizesMale(params) {
  return async (dispatch, getState) => {

    dispatch({
      type: 'SIZES_REQUEST'
    }, getState);
    let data;
    try {
      data = await Client.getSizesMale(params);
    } catch (error) {
      dispatch(batchActions([{
        type: 'SIZES_REQUEST_FAIL',
        error,
      },
      ]), getState);
      return {
        error
      };
    }

    dispatch(batchActions([
      {
        type: 'SIZES_SMART_UPDATED',
        data: params,
      },
      {
        type: 'SIZES_REQUEST_RECEIVED',
        data
      }
    ]));

    return { data };
  };
}
